module.exports = __webpack_public_path__ + "img/pennellata-oderzo.ff1d4a49.png";